// ------------------------------------------------------------------------------
// name: useShareArtist
// author: mudas
// created: 2024/12/8
// ------------------------------------------------------------------------------

import { useState } from 'react';
import { ROUTER_PATHNAME } from 'common/router/config';
import service, { isSuccessCode } from 'common/service';

export const useShareArtist = () => {
  const [loading, setLoading] = useState<boolean>(false);

  const getShareURL = async (): Promise<string> => {
    setLoading(true);

    const path = window.location.origin;

    return new Promise<any>(async (resolve, reject) => {
      try {
        const res = await service.artistV2.getConcernsShareId();

        if (!isSuccessCode(res?.code)) throw new Error(res?.message);

        return resolve([path, `${ROUTER_PATHNAME.SHARE_ARTIST}?id=${res.data.shareId}`].join('/'));
      } catch (error) {
        return reject(error);
      }
    }).finally(() => {
      setLoading(false);
    });
  };

  return { loading, getShareURL };
};
